/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2PaymentsSubscribeByPlanParams,
  PostV2PaymentsUnsubscribeQuery,
  PostV2PaymentsSubscribeByPlanQuery,
  PostV2PaymentsCreditsBuyQuery,
  PostV2PaymentsUnsubscribeResponse,
  PostV2PaymentsSuccessResponse,
  PostV2PaymentsSubscribeByPlanResponse,
  PostV2PaymentsCreditsBuyResponse,
  PostV2PaymentsCancelResponse,
  GetV2PaymentsInvoicesResponse,
} from '../types';

export class StripeController extends Controller {
  async postV2PaymentsUnsubscribe<
    T extends PostV2PaymentsUnsubscribeResponse,
    D,
    C extends null
  >(
    body: C,
    query: PostV2PaymentsUnsubscribeQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/v2/payments/unsubscribe', query),
      body,
      axiosConfig
    );
  }

  async postV2PaymentsSuccess<
    T extends PostV2PaymentsSuccessResponse,
    D,
    C extends null
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/payments/success',
      body,
      axiosConfig
    );
  }

  async postV2PaymentsSubscribeByPlan<
    T extends PostV2PaymentsSubscribeByPlanResponse,
    D,
    C extends null
  >(
    body: C,
    { plan }: PostV2PaymentsSubscribeByPlanParams,
    query: PostV2PaymentsSubscribeByPlanQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/v2/payments/subscribe/${plan}`, query),
      body,
      axiosConfig
    );
  }

  async postV2PaymentsCreditsBuy<
    T extends PostV2PaymentsCreditsBuyResponse,
    D,
    C extends null
  >(
    body: C,
    query: PostV2PaymentsCreditsBuyQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      this.composeUrl('/v2/payments/credits/buy', query),
      body,
      axiosConfig
    );
  }

  async postV2PaymentsCancel<
    T extends PostV2PaymentsCancelResponse,
    D,
    C extends null
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/payments/cancel',
      body,
      axiosConfig
    );
  }

  async getV2PaymentsInvoices<T extends GetV2PaymentsInvoicesResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/v2/payments/invoices',
      axiosConfig
    );
  }
}
